<template>
  <div class="overlay" v-if="isVisible">
    <div class="paymentMethodModal">
      <b class="paymentMethod" v-if="mode !== 'Delete'"
        >{{ mode }} Payment Method</b
      >
      <b class="paymentMethod" v-else>Delete {{ paymentMethod.name }}</b>
      <div
        class="flexCol scroll"
        v-if="mode !== 'Change' && mode !== 'Delete'"
        style="width: 100%"
      >
        <div class="row" style="width: 100%">
          <div class="col-3 align-content-center">Method Type</div>
          <div class="col-9">
            <hilo-select
              :options="types"
              theme="grey"
              v-model="billingTypeId"
              placeholder="Type..."
              v-if="mode !== 'Edit'"
            ></hilo-select>
            <div v-else class="text-center">
              {{ types?.find((data) => data.id === billingTypeId)?.name }}
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 4">
          <div class="col-3 align-content-center">Provider</div>
          <div class="col-9">
            <input type="text" v-model="provider" placeholder="Provider..." />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 1">
          <div class="col-3 align-content-center">Bank Name</div>
          <div class="col-9">
            <input type="text" v-model="bankName" placeholder="Bank..." />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 1">
          <div class="col-3 align-content-center">Bank Alias</div>
          <div class="col-9">
            <input type="text" v-model="alias" placeholder="Alias..." />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId">
          <div class="col-3 align-content-center">
            {{ { 1: "Account", 4: "Card" }[billingTypeId] || "" }} First Name
          </div>
          <div class="col-9">
            <input
              type="text"
              v-model="firstName"
              placeholder="First Name..."
            />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId">
          <div class="col-3 align-content-center">
            {{ { 1: "Account", 4: "Card" }[billingTypeId] || "" }} Last Name
          </div>
          <div class="col-9">
            <input type="text" v-model="lastName" placeholder="Last Name..." />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 4">
          <div class="col-3 align-content-center">Card Number</div>
          <div class="col-9">
            <input
              type="text"
              v-model="cardNumber"
              placeholder="Card Number..."
            />
          </div>
        </div>
        <div class="flexRow" v-if="billingTypeId === 4">
          <div class="row" style="width: 50%">
            <div class="col-3 align-content-center">CVV</div>
            <div class="col-9">
              <input type="text" v-model="cvv" placeholder="CVV..." />
            </div>
          </div>
          <div class="row" style="width: 50%">
            <div class="col-3 align-content-center">Expr. Date</div>
            <div class="col-9">
              <input
                type="date"
                v-model="expirationDate"
                placeholder="Eprx. Date..."
              />
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 1">
          <div class="col-3 align-content-center">Account Number</div>
          <div class="col-9">
            <input
              type="text"
              v-model="accountNumber"
              placeholder="Account Number..."
            />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 1">
          <div class="col-3 align-content-center">Routing Number</div>
          <div class="col-9">
            <input
              type="text"
              v-model="routingNumber"
              placeholder="Routing Number..."
            />
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId === 1">
          <div class="col-3 align-content-center">Account Type</div>
          <div class="col-9">
            <hilo-select
              :options="accountTypes"
              theme="grey"
              v-model="accountType"
              placeholder="Account Type..."
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="width: 100%" v-if="billingTypeId">
          <div class="col-3 align-content-center">Address</div>
          <div class="col-9">
            <input
              type="text"
              v-model="billingAddress"
              placeholder="Address..."
            />
          </div>
        </div>
        <div class="flexRow">
          <div class="row" style="width: 50%" v-if="billingTypeId">
            <div class="col-3 align-content-center">City</div>
            <div class="col-9">
              <input type="text" v-model="billingCity" placeholder="City..." />
            </div>
          </div>
          <div class="row" style="width: 50%" v-if="billingTypeId">
            <div class="col-3 align-content-center">Zip</div>
            <div class="col-9">
              <input type="text" v-model="billingZip" placeholder="Zip..." />
            </div>
          </div>
        </div>
        <div class="flexRow">
          <div class="row" style="width: 50%" v-if="billingTypeId">
            <div class="col-3 align-content-center">State</div>
            <div class="col-9">
              <input
                type="text"
                v-model="billingState"
                placeholder="State..."
              />
            </div>
          </div>
          <div class="row" style="width: 50%" v-if="billingTypeId">
            <div class="col-3 align-content-center">Country</div>
            <div class="col-9">
              <input
                type="text"
                v-model="billingCountry"
                placeholder="Country..."
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="row text-center"
        style="width: 100%"
        v-else-if="mode === 'Delete'"
      >
        <div class="col-12 text-center">
          <label
            >Please select a replacement payment method in order to delete
            {{ paymentMethod.name }}</label
          >
          <hilo-select
            :options="allPaymentMethods"
            theme="grey"
            v-model="selectedPaymentMethodId"
            placeholder="Select a Replacement..."
            v-if="allPaymentMethods"
            style="width: 50%; margin: auto"
          ></hilo-select>
          <br />
        </div>
        <div class="col-6">
          <el-button
            :disabled="!selectedPaymentMethodId"
            type="success"
            @click="submit"
            >Confirm</el-button
          >
        </div>
        <div class="col-6">
          <el-button type="danger" @click="closeModal">Cancel</el-button>
        </div>
      </div>
      <div v-else style="width: 50%">
        <hilo-select
          :options="allPaymentMethods"
          theme="grey"
          v-model="selectedPaymentMethodId"
          placeholder="Select a Method..."
          v-if="allPaymentMethods"
        ></hilo-select>
      </div>
      <button
        v-if="mode !== 'Delete'"
        :disabled="submitDisabled"
        @click="submit"
      >
        {{ mode !== "Create" ? "Update" : "Save" }}
      </button>

      <img
        class="closeButton"
        alt=""
        src="/static/img/grey-x.svg"
        @click="closeModal"
      />
    </div>
  </div>
</template>
<script>
//Both: billingAddress, billingCity, billingZip, billingState, billingCountry, firstName, lastName,
import crypto from "crypto-js";
import dayjs from "dayjs";
import { Button } from "element-ui";
import { useLoginStore } from "../../../../../stores/loginStore";
import HiloSelect from "../../../../../components/HiloComponents/HiloSelect.vue";
import BillingAPIService from "../../../../../servicehandlers/BillingAPIService";
import PaymentMethodsAPIService from "../../../../../servicehandlers/PaymentMethodsAPIService";

const billingAPIService = new BillingAPIService();
const paymentMethodsAPIService = new PaymentMethodsAPIService();
export default {
  name: "PaymentMethodModal",
  components: {
    HiloSelect,
    [Button.name]: Button,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    paymentMethod: {
      type: Object,
      required: false,
    },
    allPaymentMethods: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      types: [],
      billingTypeId: 0,
      original: null,

      bankName: "",
      alias: "",
      accountNumber: "",
      routingNumber: "",
      accountType: "",

      provider: "",
      firstName: "",
      lastName: "",
      cardNumber: "",
      cvv: "",
      expirationDate: "",

      billingAddress: "",
      billingCity: "",
      billingZip: "",
      billingState: "",
      billingCountry: "",

      accountTypes: [
        {
          id: "Checking",
          name: "Checking",
        },
        {
          id: "Saving",
          name: "Saving",
        },
      ],
      flightSchoolId: useLoginStore().getUser.flightSchoolId,
      selectedPaymentMethodId: null,
    };
  },
  async mounted() {
    await this.getBillingTypes();
    if (this.mode === "Edit") {
      this.billingTypeId = this.paymentMethod.billingTypeId;
      this.getMethod();
    } else {
      this.billingTypeId = 0;
      this.clear();
    }
  },
  computed: {
    submitDisabled() {
      if (this.mode === "Change") {
        return !this.selectedPaymentMethodId;
      } else if (this.mode === "Edit") {
        let typeName = this.types?.find(
          (data) => data.id === this.billingTypeId,
        )?.name;
        let value = true;
        let valid = true;
        if (!typeName || !this.original) return value;
        switch (typeName) {
          case "Account":
            value = !(
              this.bankName &&
              this.alias &&
              this.firstName &&
              this.lastName &&
              this.accountNumber &&
              this.routingNumber &&
              this.accountType
            );
            valid =
              this.bankName === this.original.bankName &&
              this.alias === this.paymentMethod.provider &&
              this.firstName === this.original.accountHolderFirstName &&
              this.lastName === this.original.accountHolderLastName &&
              this.accountNumber ===
                crypto.AES.decrypt(
                  this.original.accountNumber,
                  process.env.VUE_APP_ENCRYPTION_SECRET,
                ).toString(crypto.enc.Utf8) &&
              this.routingNumber === this.original.routingNumber &&
              this.accountType === this.original.accountType;
            break;
          case "Credit Card":
            value = !(
              this.provider &&
              this.firstName &&
              this.lastName &&
              this.cardNumber &&
              this.cvv &&
              this.expirationDate
            );
            valid =
              this.provider === this.original.provider &&
              this.firstName === this.original.cardHolderFirstName &&
              this.lastName === this.original.cardHolderLastName &&
              this.cardNumber ===
                crypto.AES.decrypt(
                  this.original.cardNumber,
                  process.env.VUE_APP_ENCRYPTION_SECRET,
                ).toString(crypto.enc.Utf8) &&
              this.cvv ===
                crypto.AES.decrypt(
                  this.original.cvv,
                  process.env.VUE_APP_ENCRYPTION_SECRET,
                ).toString(crypto.enc.Utf8) &&
              this.expirationDate ===
                dayjs(this.original.expirationDate).format("YYYY-MM-DD");
            break;
        }

        let addressValue = !(
          this.billingAddress &&
          this.billingCity &&
          this.billingZip &&
          this.billingState &&
          this.billingCountry
        );

        let addressValid =
          this.billingAddress === this.original.billingAddress &&
          this.billingCity === this.original.billingCity &&
          this.billingZip === this.original.billingZip &&
          this.billingState === this.original.billingState &&
          this.billingCountry === this.original.billingCountry;

        return value || addressValue || (valid && addressValid);
        //return value || valid || addressValue || addressValid
      } else if (this.mode === "Create") {
        let typeName = this.types?.find(
          (data) => data.id === this.billingTypeId,
        )?.name;
        let value = true;
        if (!typeName) return value;
        switch (typeName) {
          case "Account":
            value = !(
              this.bankName &&
              this.alias &&
              this.firstName &&
              this.lastName &&
              this.accountNumber &&
              this.routingNumber &&
              this.accountType
            );
            break;
          case "Credit Card":
            value = !(
              this.provider &&
              this.firstName &&
              this.lastName &&
              this.cardNumber &&
              this.cvv &&
              this.expirationDate
            );
            break;
        }

        let addressValue = !(
          this.billingAddress &&
          this.billingCity &&
          this.billingZip &&
          this.billingState &&
          this.billingCountry
        );

        return value || addressValue;
      }
      return true;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    getBillingTypes() {
      return billingAPIService
        .getBillingTypes(this.$router)
        .then((response) => {
          this.types = response;
        });
    },
    getMethod() {
      let VO = this;
      if (this.paymentMethod.billingType.name === "Account") {
        return paymentMethodsAPIService
          .getAccountById(this.paymentMethod.methodId, this.$router)
          .then((response) => {
            this.original = JSON.parse(JSON.stringify(response));
            this.firstName = response.accountHolderFirstName;
            this.lastName = response.accountHolderLastName;
            this.bankName = response.bankName;
            this.alias = this.paymentMethod.provider;
            this.accountNumber = crypto.AES.decrypt(
              response.accountNumber,
              process.env.VUE_APP_ENCRYPTION_SECRET,
            ).toString(crypto.enc.Utf8);
            this.routingNumber = response.routingNumber;
            this.accountType = response.accountType;
            getBillingInfo(response);
          });
      } else if (this.paymentMethod.billingType.name === "Credit Card") {
        return paymentMethodsAPIService
          .getCreditCardById(this.paymentMethod.methodId, this.$router)
          .then((response) => {
            this.original = JSON.parse(JSON.stringify(response));
            this.firstName = response.cardHolderFirstName;
            this.lastName = response.cardHolderLastName;
            this.cardNumber = crypto.AES.decrypt(
              response.cardNumber,
              process.env.VUE_APP_ENCRYPTION_SECRET,
            ).toString(crypto.enc.Utf8);
            this.cvv = crypto.AES.decrypt(
              response.cvv,
              process.env.VUE_APP_ENCRYPTION_SECRET,
            ).toString(crypto.enc.Utf8);
            this.provider = response.provider;
            this.expirationDate = dayjs(response.expirationDate).format(
              "YYYY-MM-DD",
            );
            getBillingInfo(response);
          });
      }
      function getBillingInfo(response) {
        VO.billingAddress = response.billingAddress;
        VO.billingCity = response.billingCity;
        VO.billingZip = response.billingZip;
        VO.billingState = response.billingState;
        VO.billingCity = response.billingCity;
        VO.billingCountry = response.billingCountry;
      }
    },
    clear() {
      this.billingTypeId = 0;
      this.firstName = "";
      this.lastName = "";
      this.cardNumber = "";
      this.cvv = "";
      this.expirationDate = "";

      this.bankName = "";
      this.alias = "";
      this.accountNumber = "";
      this.routingNumber = "";
      this.accountType = "";

      this.billingAddress = "";
      this.billingCity = "";
      this.billingZip = "";
      this.billingState = "";
      this.billingCountry = "";

      this.selectedPaymentMethodId = null;
    },
    async submit() {
      switch (this.mode) {
        case "Change":
          this.$emit("select", this.selectedPaymentMethodId);
          this.closeModal();
          break;
        case "Edit":
        case "Create":
          let payload = {
            method: {
              billingAddress: this.billingAddress,
              billingCity: this.billingCity,
              billingZip: this.billingZip,
              billingState: this.billingState,
              billingCountry: this.billingCountry,
            },
            billingTypeId: this.billingTypeId,
            flightSchoolId: this.flightSchoolId,
          };

          if (this.billingTypeId === 1) {
            payload.provider = this.alias;
            payload.method.bankName = this.bankName;
            payload.method.accountNumber = crypto.AES.encrypt(
              this.accountNumber,
              process.env.VUE_APP_ENCRYPTION_SECRET,
            ).toString();
            payload.method.routingNumber = this.routingNumber;
            payload.method.accountType = this.accountType;
            payload.method.accountHolderFirstName = this.firstName;
            payload.method.accountHolderLastName = this.lastName;
            payload.lastFourDigits = this.accountNumber.slice(
              this.accountNumber.length - 4,
            );
          } else if (this.billingTypeId === 4) {
            payload.provider = this.provider;
            payload.method.firstName = this.firstName;
            payload.method.lastName = this.lastName;
            payload.method.cardNumber = crypto.AES.encrypt(
              this.cardNumber,
              process.env.VUE_APP_ENCRYPTION_SECRET,
            ).toString();
            payload.method.cvv = crypto.AES.encrypt(
              this.cvv,
              process.env.VUE_APP_ENCRYPTION_SECRET,
            ).toString();
            payload.method.expirationDate = this.expirationDate;
            payload.method.cardHolderFirstName = this.firstName;
            payload.method.cardHolderLastName = this.lastName;
            payload.method.provider = this.provider;
            payload.lastFourDigits = this.cardNumber.slice(
              this.cardNumber.length - 4,
            );
          }

          if (this.mode === "Create") {
            return paymentMethodsAPIService
              .createPaymentMethod(payload, this.$router)
              .then((response) => {
                this.$emit("select", response.id);
                this.closeModal();
              });
          } else if (this.mode === "Edit") {
            return paymentMethodsAPIService
              .updatePaymentMethod(this.paymentMethod.id, payload, this.$router)
              .then(() => {
                this.$emit("update");
                this.closeModal();
              });
          }
          break;
        case "Delete":
          let deleteId = this.paymentMethod.id;
          this.$emit("select", this.selectedPaymentMethodId);
          return paymentMethodsAPIService
            .deletePaymentMethod(deleteId, this.$router)
            .then(() => {
              this.$emit("update");
              this.closeModal();
            });
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  opacity: 50%;
  cursor: not-allowed;
}
.flexCol {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.flexRow {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.row {
  margin: 0 !important;
}
.paymentMethod {
  position: relative;
  font-size: 25px;
  white-space: nowrap;
  z-index: 0;
  width: 100% !important;
  text-align: center;
}
.closeButton {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.paymentMethodModal {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica;
  max-height: 80%;
}
.scroll {
  min-height: 130px;
  overflow-y: auto; /* Enable vertical scrolling */
}

.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
